import { recommandationMapping, lignesCommandeToPanneaux } from '@/services/recommandation/recommandationMapping';

const LNG_MIN = -5;
const LNG_MAX = 12;
const LAT_MIN = 40;

function aDesCoordonnees(adresse) {
  return !!(adresse && adresse.coordonnees
    && adresse.coordonnees.lng > LNG_MIN && adresse.coordonnees.lng < LNG_MAX && adresse.coordonnees.lat > LAT_MIN);
}

function estSousContrat(panneau) {
  return (panneau.ancienPanneau || 'NON').toUpperCase() === 'OUI';
}

export function mapRecommandationsClient(recommandationsDto) {
  return recommandationsDto.map(devis => {
    const recommandation = recommandationMapping(devis);
    if (devis.afficherPanneauxSousContrat && devis.lignesSousContrat && devis.lignesSousContrat.length) {
      const panneauxSousContrat = lignesCommandeToPanneaux(devis.lignesSousContrat, devis.societe)
        .map(panneau => ({ ...panneau, ancienPanneau: 'OUI' }));
      recommandation.panneaux.push(...panneauxSousContrat);
    }
    return {
      ...recommandation,
      idEnseigne: recommandation.pointDeVente.tiersParentId,
      previewLink: devis.portailAnnonceurLink,
      montant: devis.montantHt,
    };
  });
}

export function mapPointsDeVente(recommandations) {
  return recommandations.map(recommandation => {
    const pointDeVente = recommandation.pointDeVente;
    const panneaux = recommandation.panneaux || [];
    return {
      id: pointDeVente.id,
      adresse: pointDeVente.adressePostale,
      libelle: pointDeVente.nomCommercial,
      srcImg: pointDeVente.urlLogo,
      icon: pointDeVente.iconMarker,
      idEnseigne: pointDeVente.tiersParentId,
      previewLink: recommandation.previewLink,
      montant: recommandation.montant,
      nbrePanneaux: panneaux.length,
      nbrePanneauxNew: panneaux.filter(panneau => !estSousContrat(panneau)).length,
      nbrePanneauxOld: panneaux.filter(estSousContrat).length,
    };
  });
}

export function mapPanneaux(recommandations) {
  return recommandations
    .flatMap(recommandation => (recommandation.panneaux || []).map(panneau => ({
      adresse: panneau.adresse,
      categorie: panneau.categorie,
      azimut: panneau.azimut,
      idEnseigne: recommandation.pointDeVente.tiersParentId,
      ancienPanneau: estSousContrat(panneau) ? 'OUI' : 'NON',
      estPanneauSousContrat: estSousContrat(panneau),
    })))
    .filter(panneau => aDesCoordonnees(panneau.adresse));
}
